import { render, staticRenderFns } from "./PharmaceuticsModuleComponent.vue?vue&type=template&id=c4636cf4&scoped=true"
import script from "./PharmaceuticsModuleComponent.vue?vue&type=script&lang=js"
export * from "./PharmaceuticsModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./PharmaceuticsModuleComponent.vue?vue&type=style&index=0&id=c4636cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4636cf4",
  null
  
)

export default component.exports